// extracted by mini-css-extract-plugin
export var createdDate = "_kj-1";
export var divider = "_kj-2";
export var headerDivider = "_kj-3";
export var messagesCard = "_kj-0";
export var messagesContainer = "_kj-6";
export var messagesContainerWrapper = "_kj-4";
export var showLeftPanelButton = "_kj-8";
export var topButtons = "_kj-7";
export var withPadding = "_kj-5";